import {
  Skeleton,
  SkeletonButton,
  SkeletonText,
  SkeletonTitle,
} from './SkeletonComponents';

export function ExpenseCreateSkeleton() {
  return (
    <div className="max-w-2xl mx-auto">
      {/* Header - matching actual layout */}
      <div className="flex items-center mb-8">
        <div className="mr-4 p-2 rounded-lg">
          <Skeleton className="w-5 h-5" />
        </div>
        <div>
          <SkeletonTitle className="w-32 mb-2" />
          <div className="flex items-center gap-1">
            <SkeletonText className="w-36" />
            <SkeletonText className="w-28 bg-orange-200" />
          </div>
        </div>
      </div>

      {/* Form - matching actual ExpenseBasicInfo layout exactly */}
      <div className="space-y-6">
        {/* Card matching actual component structure */}
        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-xs p-6">
          <div className="space-y-4">
            {/* Amount and Title - matching actual grid layout */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {/* Amount field */}
              <div>
                <Skeleton className="w-20 h-4 mb-1" />
                <Skeleton className="w-full h-12 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700" />
              </div>

              {/* Title field - spans 2 columns */}
              <div className="sm:col-span-2">
                <Skeleton className="w-32 h-4 mb-1" />
                <Skeleton className="w-full h-12 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700" />
              </div>
            </div>
          </div>
        </div>

        {/* Form Actions - matching actual layout with dark mode */}
        <div className="flex justify-end space-x-3">
          <SkeletonButton className="w-20" />
          <SkeletonButton className="w-28 bg-orange-500 dark:bg-orange-600" />
        </div>
      </div>
    </div>
  );
}
